import { UseState } from '@types';

export const closeMobileNavbarAfterChangePage = (setIsOpenNavbarMobile: UseState<boolean>) => () =>
  setIsOpenNavbarMobile(false);
